export const DEFAULT_CONFIG = {
    projectSecret: "",
    position: "bottom-right",
    primaryColor: "#fb2c36",
    secondaryColor: "#fb2c36",
    textColor: "#333333",
    backgroundColor: "#FFFFFF",
    theme: "light",
    buttonText: "",
    buttonIcon: "feedaura",
    iconColor: "#FFFFFF",
    buttonSize: "medium",
    buttonRadius: "50%",
    widgetStyle: "floating",
    apiEndpoint: "https://feedaura.feedaura-ai.workers.dev/feedbacks",
    zIndex: 9999,
    autoCloseAfterSubmit: true,
    animated: true,
    productName: "product",
    placeholder: "Please write here",
    submitText: "Submit",
    headerText: "Give us your feedback",
    questionText: "What was your experience while using our product?",
    feedbackLabelText: "Write your feedback",
    // Support legacy config names
    themeColor: "#fb2c36", // Maps to primaryColor
};

export const EMOJI_OPTIONS = [
    { emoji: "😞", label: "Poor" },
    { emoji: "😐", label: "Fair" },
    { emoji: "😊", label: "Good" },
    { emoji: "😍", label: "Great" },
    { emoji: "🤩", label: "Amazing" },
];

export const BUTTON_SIZES = {
    small: {
        padding: "10px",
        fontSize: "12px",
        iconSize: 30,
        height: 52,
        width: 52,
    },
    medium: {
        padding: "12px",
        fontSize: "14px",
        iconSize: 35,
        height: 60,
        width: 60,
    },
    large: {
        padding: "16px",
        fontSize: "16px",
        iconSize: 40,
        height: 65,
        width: 65,
    },
};

export const POSITIONS = [
    "bottom-right",
    "bottom-left",
    "top-right",
    "top-left",
];

/**
 * Create normalized configuration by merging user config with defaults
 * @param {Object} userConfig - User provided configuration
 * @returns {Object} Normalized configuration
 */
export function createConfig(userConfig = {}) {
    const config = { ...DEFAULT_CONFIG, ...userConfig };

    // Handle legacy property names
    if (userConfig.themeColor) {
        config.primaryColor = userConfig.themeColor;
    }

    // Validate configuration
    validateConfig(config);

    return config;
}

/**
 * Validate configuration values
 * @param {Object} config - Configuration to validate
 */
function validateConfig(config) {
    if (!POSITIONS.includes(config.position)) {
        console.warn(
            `Invalid position: ${config.position}. Using default: bottom-right`
        );
        config.position = "bottom-right";
    }

    if (!BUTTON_SIZES[config.buttonSize]) {
        console.warn(
            `Invalid button size: ${config.buttonSize}. Using default: small`
        );
        config.buttonSize = "small";
    }
}
